export const UTMdataFilter =( data, resultObj, replaceLabel) => {
    // console.log("🔍 UTMdataFilter called with:");
    console.log("   data:", JSON.stringify(data, null, 2));
    // console.log("   resultObj:", resultObj);
    // console.log("   replaceLabel:", replaceLabel);
    // console.log("   data[0] keys:", Object.keys(data[0]));
    // console.log("   data[0] structure:", data[0]);
    
    for (let i = 0; i < Object.keys(data[0]).length; i++) {
      const weekKey = Object.keys(data[0])[i];
      // console.log(`🔍 Processing week ${i}: ${weekKey}`);
      
      // Sets the weeks labels
      let tempWeek = weekKey?.replace("(Week of", "")?.replace(")", "");
      if (tempWeek !== "graph-options") {
        resultObj.weeks[i] = tempWeek;
        // console.log(`🔍   Set week[${i}] = ${tempWeek}`);
      }
      
      if (weekKey === "graph-options") {
        console.log("🔍   Skipping graph-options");
        continue;
      }
      
      const weekData = data[0][weekKey];
      // console.log(`🔍   Week data:`, weekData);
      // console.log(`🔍   Object.values(weekData):`, Object.values(weekData));
      
      const weekValues = Object.values(weekData);
      // console.log(`🔍   Week values[0]:`, weekValues[0]);
      // console.log(`🔍   Week values[1]:`, weekValues[1]);
      
      try {
        // Sets the number of visitors values
        const visitorsData = weekValues[0][0].data;
        resultObj.visitors[i] = visitorsData;
        // console.log(`🔍   Set visitors[${i}] =`, visitorsData);
        
        // Sets the percent of visitors booking values
        const bookingData = weekValues[0][1].data;
        resultObj.percentBooking[i] = bookingData;
        // console.log(`🔍   Set percentBooking[${i}] =`, bookingData);
        
        // sets the utm-params ads label
        const labels = weekValues[1].map((str) => {
          let temp = str.replace(replaceLabel, "");
          return temp;
        });
        resultObj.labels[i] = labels;
        // console.log(`🔍   Set labels[${i}] =`, labels);
        
        // Sets the percent of visitors bought values
        if (weekValues[0][2] !== undefined) {
          const boughtData = weekValues[0][2].data;
          resultObj.percentBought[i] = boughtData;
          // console.log(`🔍   Set percentBought[${i}] =`, boughtData);
        } else {
          resultObj.percentBought[i] = [0];
          // console.log(`🔍   Set percentBought[${i}] = [0] (default)`);
        }
      } catch (error) {
        console.error(`🔍 Error processing week ${i} (${weekKey}):`, error);
        console.error("🔍 Error stack:", error.stack);
      }
    }
    
    // console.log("🔍 UTMdataFilter final result:", resultObj);
    return resultObj;
}